import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as R from 'ramda'

import Deleted from 'components/Deleted'

import { doc, dirtyRead } from 'selectors/common'

import dataActions from 'actions/dataActions'

let select = dirtyRead(
	(state, props) => ({
		property: doc(state, props.propertyID )
	})
)

export class ExternalLinks extends Component{
	render(){
		let { props } = this
		let propertyID = props.propertyID
		let address = props.property.address || ""
		return(
			<div className="links">
				<a
					href={
						(
							props.property.cors
							&& props.property.cors.lat
							&& props.property.cors.lng
						)?`http://www.greatschools.org/search/search.page?lat=${
								props.property.cors.lat
							}&lon=${
								props.property.cors.lng
							}&zipCode=${
								address.split(' ')[address.split(' ').length - 1]
							}&state=${
								address.split(' ')[address.split(' ').length - 2]
							}&locationType=street_address&normalizedAddress=${
								address.split(' ').join('%20')
							}&sortBy=DISTANCE&distance=5`
							:
							''
					}
					target="_blank"
					style={{
						display: 'inline-block'
					  , textAlign: 'center'
					  , margin: "0 10px"
					  , width: "25px"
					  , height: "25px"
					  , background: "#607d8b"
					  , borderRadius: "100%"
					}}
					className="external-property-link"
					title = "Explore on Greatschools"
				>
					<div
						style={{
							width: '100%'
						, height: '100%'
						, backgroundImage: `url(${'/' + process.env.REACT_APP_NAME + "/static/img/logo_greatschool.png"})`
						, backgroundSize: "50%"
						, backgroundPosition: "50%"
						, backgroundRepeat: "no-repeat"
						}}
					>
					</div>
				</a>
				<a
					href={
						`http://www.zillow.com/homes/${address.split(' ').join('-')}_rb/?fromHomePage=true&shouldFireSellPageImplicitClaimGA=false`
					}
					target="_blank"
					style={{
						display: 'inline-block'
					  , textAlign: 'center'
					  , margin: "0 10px"
					  , width: "25px"
					  , height: "25px"
					  , background: "#607d8b"
					  , borderRadius: "100%"
					}}
					className="external-property-link"
					title = "Explore on Zilow"
				>
					<div
						style={{
							width: '100%'
						, height: '100%'
						, backgroundImage: `url(${'/' + process.env.REACT_APP_NAME + "/static/img/logo_zillow.png"})`
						, backgroundSize: "70%"
						, backgroundPosition: "50%"
						, backgroundRepeat: "no-repeat"
						}}
					>
					</div>
				</a>
				<a
					href={`http://zipwho.com/?zip=${address.split(' ')[address.split(' ').length - 1]}&city=&filters=--_--_--_--&state=&mode=zip`}
					target="_blank"
					style={{
						display: 'inline-block'
					  , textAlign: 'center'
					  , margin: "0 10px"
					  , width: "25px"
					  , height: "25px"
					  , background: "#607d8b"
					  , borderRadius: "100%"
					}}
					className="external-property-link"
					title = "Explore on Zipwho"
				>
					<div
						style={{
							width: '100%'
						, height: '100%'
						, backgroundImage: `url(${'/' + process.env.REACT_APP_NAME + "/static/img/logo_zipwho.png"})`
						, backgroundSize: "70%"
						, backgroundPosition: "50%"
						, backgroundRepeat: "no-repeat"
						}}
					>
					</div>
				</a>
			</div>
		)
	}
}

export default connect(select, R.mergeAll([dataActions]))(ExternalLinks)



// WEBPACK FOOTER //
// ./src/components/ExternalLinks.js